module.exports = __webpack_public_path__ + "img/events-01.30b259a5.png";